<template>
  <div class="relative z-10 w-full">
    <ol
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
      class="flex flex-wrap items-center"
    >
      <template v-for="(item, item_index) in path">
        <li
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
          class="mr-2"
          :key="`path_${item_index}_link`"
        >
          <router-link
            itemscope
            itemtype="https://schema.org/WebPage"
            itemprop="item"
            :itemid="`${base_url}${item.link}`"
            :to="item.link"
            class="text-xs"
          >
            <span
              itemprop="name"
              :class="
                item_index == path.length - 1
                  ? `${active_text_color} `
                  : secondary_text_color
              "
            >
              {{ item.title }}
            </span>
          </router-link>
          <meta itemprop="position" :content="item_index + 1" />
        </li>
        <li
          v-if="item_index != path.length - 1"
          :key="`path_${item_index}_arrow`"
        >
          <span class="block mr-2">
            <i
              class="block text-xs mt-[4px] text-zinc-600 transform icon-chevron-left -scale-75"
            ></i>
          </span>
        </li>
      </template>
    </ol>
  </div>
</template>
<script>
export default {
  name: "BreadCrumb",
  props: {
    path: {
      require: true,
      type: Array,
    },
    dark_mode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active_text_color() {
      return this.dark_mode ? "text-white" : "text-light-black";
    },
    secondary_text_color() {
      return this.dark_mode ? "text-zinc-300" : "text-zinc-600";
    },
    base_url() {
      return process.env.VUE_APP_BASEURL;
    },
  },
};
</script>
